<template>
  <div class="">
    <el-form :inline="true" :model="searchQuery" class="demo-form-inline" size="small" label-width="100px">
      <el-row>
        <el-col :span="4" style="margin-right: 0.625rem;">

          <el-select filterable v-model="searchQuery.country" placeholder="区域国家" clearable="clearable">

            <el-option :label="item.zh_name" :value="item.zh_name" v-for="(item,index) in countyList" :key="index">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="4" style="margin-right: 0.625rem;">
          <el-select filterable v-model="searchQuery.type" placeholder="签证大类" clearable="clearable">
            <el-option label="旅游签证" value="旅游签证"></el-option>
            <el-option label="电子签证" value="电子签证"></el-option>
            <el-option label="商务签证" value="商务签证"></el-option>
            <el-option label="探亲访友签" value="探亲访友签"></el-option>
          </el-select>
        </el-col>

        <el-col :span="4" style="margin-right: 0.625rem;">
          <el-select v-model="searchQuery.consular" placeholder="领区" clearable="clearable">
            <el-option label="全国" value="全国"></el-option>
            <el-option label="北京" value="北京"></el-option>
            <el-option label="上海" value="上海"></el-option>
            <el-option label="广州" value="广州"></el-option>
            <el-option label="深圳" value="深圳"></el-option>
            <el-option label="成都" value="成都"></el-option>
            <el-option label="厦门" value="厦门"></el-option>
            <el-option label="南宁" value="南宁"></el-option>
            <el-option label="武汉" value="武汉"></el-option>
            <el-option label="香港" value="香港"></el-option>
            <el-option label="重庆" value="重庆"></el-option>
            <el-option label="沈阳" value="沈阳"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="margin-right: 0.625rem;">
          <el-form-item>
            <el-input style="width: 100%;height: 2.5rem;" v-model="searchQuery.keyword" placeholder="关键字"
              clearable="clearable"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item>
            <el-button type="primary" @click="getDataList">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="tabs_box">
      <el-table :data="DataList" v-if="DataList.length > 0" style="width: 100%" cell-class-name="cell_Name"
        v-loading="loading"
        :header-cell-style="{ background: '#fafbfc',borderTop: '1px solid #eee',padding:'1.25rem 0'}">
        <el-table-column prop="ViasName" label="产品名称" width="200">
        </el-table-column>
        <!-- 					<el-table-column prop="name" label="国家-领区" width="180">
					</el-table-column>
					<el-table-column prop="address" label="签证大类-小类">
				 </el-table-column> -->

        <el-table-column prop="CountryArea" label="国家-领区" width="200">

        </el-table-column>

        <el-table-column prop="VisaType" label="签证大类-小类" width="200">

        </el-table-column>

        <el-table-column prop="FloorPrice" label="成本价" width="130">

        </el-table-column>


        <el-table-column prop="AddLimit" label="分销价" width="130">
          <template slot-scope="scope">
            <el-input v-model="scope.row.AddLimit" @input="inputScope"></el-input>
          </template>
        </el-table-column>

        <el-table-column prop="StorePrice" label="直客价" width="130">
          <template slot-scope="scope">
            <el-input type="text" :min="scope.row.FloorPrice" v-model="scope.row.StorePrice" @input="inputScope">
            </el-input>
          </template>
        </el-table-column>

      </el-table>

      <div class="" v-if="DataList.length == 0">
        <el-empty description="暂无数据"></el-empty>
      </div>

      <div class="btn_box" v-if="DataList.length > 0">
        <el-button type="primary" @click="UpdateStorePricePC">保存价格</el-button>
        <div class="block">
          <el-pagination layout="prev, pager, next" :total="count" :page-size="pageSize" :current-page="pageIndex"
            @current-change="changeIndex">
          </el-pagination>
        </div>
      </div>


    </div>

  </div>

</template>

<script>
  export default {
    name: "storeprice",
    data: function () {
      return {
        searchQuery: {
          keyword: '',
          consular: '',
          type: '',
          country: ''
        },
        countyList: [],
        DataList: [],
        pageSize: 5,
        pageIndex: 1,
        count: 0,
        loading: false,
      }
    },
    created: function () {
      this.getDataList()
      this.getCountryList()
    },
    methods: {
      getCountryList() {
        this.$api.GetCountryList().then(res => {
          this.countyList = res.data.data
        })
      },
      changeIndex(val) {
        this.pageIndex = val;
        this.getDataList()
      },

      //乘法函数，用来得到精确的乘法结果
      //说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
      //调用：this.Mul(arg1,arg2)
      //返回值：arg1乘以arg2的精确结果
      Mul(arg1, arg2) {
        arg1 = parseFloat(arg1);
        arg2 = parseFloat(arg2);
        var m = 0,
          s1 = arg1.toString(),
          s2 = arg2.toString();
        try {
          m += s1.split(".")[1].length
        } catch (e) {}
        try {
          m += s2.split(".")[1].length
        } catch (e) {}
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
      },

      Sub(arg1, arg2) {
        arg1 = parseFloat(arg1);
        arg2 = parseFloat(arg2);
        var r1, r2, m, n;
        try {
          r1 = arg1.toString().split(".")[1].length
        } catch (e) {
          r1 = 0
        }
        try {
          r2 = arg2.toString().split(".")[1].length
        } catch (e) {
          r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2));
        //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return ((this.Mul(arg1, m) - this.Mul(arg2, m)) / m).toFixed(n);
      },

      //加法函数，用来得到精确的加法结果
      //说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
      //调用：$h.Add(arg1,arg2)
      //返回值：arg1加上arg2的精确结果
      Add(arg1, arg2) {
        arg2 = parseFloat(arg2);
        var r1, r2, m;
        try {
          r1 = arg1.toString().split(".")[1].length
        } catch (e) {
          r1 = 0
        }
        try {
          r2 = arg2.toString().split(".")[1].length
        } catch (e) {
          r2 = 0
        }
        m = Math.pow(100, Math.max(r1, r2));
        return (this.Mul(arg1, m) + this.Mul(arg2, m)) / m;
      },

      inputScope(value) {

      },

      getDataList() {
        let {
          pageSize,
          pageIndex,
          searchQuery
        } = this;
        this.loading = true;
        this.$api.GetStorePricePC({
          pageSize: this.pageSize,
          PageIndex: this.pageIndex,
          country: searchQuery.country,
          consular: searchQuery.consular,
          keyword: searchQuery.keyword,
          type: searchQuery.type
        }).then(res => {
          let {
            data,
            status
          } = res.data;
          if (status == 200) {
            let list = data.list
            for (let i in list) {
              // list[i].AddLimit = Math.round(this.Mul(list[i].FloorPrice, this.Mul(list[i].scale, 0.01)))
              list[i].AddLimit = Math.round(this.Add(list[i].FloorPrice, list[i].AddLimit))
            }
            this.DataList = list
            this.count = data.count
          } else {
            this.DataList = []
            this.count = 0
          }
          this.loading = false;
        })
      },

      UpdateStorePricePC() {
        let list = this.DataList
        for (let i in list) {
          list[i].AddLimit = Math.round(this.Sub(list[i].AddLimit, list[i].FloorPrice));
        }
        console.log(list)
        this.$api.UpdateStorePricePC({
          list: list
        }).then(res => {
          let {
            data,
            status
          } = res.data;
          if (status == 200) {
            console.log(res.data)
            this.$message(res.data.message)
            this.getDataList()
          } else {
            this.$message.error(res.data.message)
          }
          console.log(res)
        }).catch(err => {
          this.$message.error(err)
        })
      },

      reset() {
        this.searchQuery = {
          keyword: '',
          consular: '',
          type: '',
          country: ''
        }
      },
    }
  }

</script>

<style lang="less" scoped>
  .cell_Name {
    font-size: 0.875rem;
  }

  .btn_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.25rem;
  }

  /deep/ .cell {
    text-align: center;

    .el-input__inner {
      height: 2rem;
      width: 60%;
      text-align: center;
    }
  }

  /deep/ .has-gutter {
    background-color: #fafbfc;
  }

  /deep/ .el-input--small .el-input__inner {
    height: 2.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/page/personcenter/storeprice.vue